import { observer, useLocalStore } from 'mobx-react-lite';
import * as React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './App.css';
import { Slide } from './components/slide';
import { Slider } from './components/slider';
import { BankComparisonSection } from './sections/bank-comparison';
import { BreakdownSection } from './sections/breakdown-section';
import { CalculatorForm } from './sections/calculator-form';
import { YearlyFeesSection } from './sections/yearly-fees';
import { FxRateService } from './services/fx-rate-service';
import { Store } from './stores/store';
import { createApiClient } from './utils/api-client';

const App = observer(() => {
    const store = useLocalStore(() => {
        const client = createApiClient();
        const service = new FxRateService(client);
        return new Store(service);
    });

    const slides = [
        <Slide key='slide-1'>
            <CalculatorForm store={store} />
        </Slide>,
        <Slide key='slide-2' title='Breakdown of your card fees'>
            <BreakdownSection store={store} />
        </Slide>,
        <Slide key='slide-3' includeSpendesk title='How does your card compare?'>
            <BankComparisonSection store={store} />
        </Slide>,
        <Slide key='slide-4' title='Yearly fees based on your budget'>
            <YearlyFeesSection store={store} />
        </Slide>,
    ];

    return (
        <div className='App'>
            <Slider slides={slides} currentIndex={store.currentSection} />
        </div>
    );
});

export default App;